enum AppointmentVisibilityType {
  Private = 'Private',
  Invitational = 'Invitational',
  Public = 'Public'
}

export { AppointmentVisibilityType }
